import { Clipboard } from '@angular/cdk/clipboard';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

const COPY_ICON = 'content_copy';
const COPY_COMPLETE_ICON = 'done';
const COPY_COMPLETE_TIMEOUT = 1200;

interface State {
  copying?: boolean;
  icon?: string;
}

@Component({
  selector: 'app-clipboard',
  template: `
    <span class="clipboard-container" *ngIf="state$$ | async as state">
      <span class="text-content" #content><ng-content></ng-content></span>
      <button
        mat-icon-button
        [matTooltip]="'COMMON.COPY_TO_CLIPBOARD' | translate"
        [attr.aria-label]="'COMMON.COPY_TO_CLIPBOARD' | translate"
        (click)="handleClick($event)"
      >
        <mat-icon>{{ state.icon }}</mat-icon>
      </button>
    </span>
  `,
  styles: [
    `
      .clipboard-container {
        display: flex;
        align-items: center;
      }
      .text-content {
        word-break: break-all;
      }
      button {
        display: flex;
        align-items: center;
      }
    `,
  ],
  standalone: false,
})
export class ClipboardComponent {
  state$$: BehaviorSubject<State> = new BehaviorSubject<State>({
    copying: false,
    icon: COPY_ICON,
  });
  @ViewChild('content') content: ElementRef;

  constructor(private clipboard: Clipboard) {}

  private get state(): State {
    return this.state$$.getValue();
  }

  private setState(state: State): void {
    this.state$$.next(Object.assign({}, { ...this.state, ...state }));
  }

  handleClick(event: MouseEvent): void {
    event.preventDefault();
    this.clipboard.copy((this.content && this.content.nativeElement && this.content.nativeElement.innerText) || '');
    if (!this.state.copying) {
      this.setState({ copying: true, icon: COPY_COMPLETE_ICON });
      window.setTimeout(() => {
        this.setState({ copying: false, icon: COPY_ICON });
      }, COPY_COMPLETE_TIMEOUT);
    }
  }
}
